export default function formatDateTime(input: string): string {
  try {
    // Parse the input string into a Date object
    const date = new Date(input);
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date format");
    }

    // Convert to Singapore timezone (Asia/Singapore)
    const singaporeDate = new Date(
      date.toLocaleString("en-US", { timeZone: "Asia/Singapore" }),
    );

    // Extract the year, month, day, hour, and minute in Singapore time
    const year = singaporeDate.getFullYear();
    const month = singaporeDate.toLocaleString("en-US", {
      month: "long",
      timeZone: "Asia/Singapore",
    });
    const day = String(singaporeDate.getDate()).padStart(2, "0");
    const hours = String(singaporeDate.getHours()).padStart(2, "0");
    const minutes = String(singaporeDate.getMinutes()).padStart(2, "0");

    // Determine AM/PM
    const hour12 = parseInt(hours, 10) % 12 || 12;
    const ampm = parseInt(hours, 10) >= 12 ? "PM" : "AM";

    // Format the output as "MMMM DD, YYYY hh:mm A"
    return `${month} ${day}, ${year} ${hour12}:${minutes} ${ampm}`;
  } catch (error) {
    console.error("Error formatting date:", (error as Error).message);
    return "Invalid date";
  }
}
